// extracted by mini-css-extract-plugin
export var banner = "_40-0";
export var icon = "_40-1";
export var message = "_40-2";